import { downgradeInjectable } from '@angular/upgrade/static';
import * as angular from 'angular';

import { RouteResolverService } from './route-resolver.service';

export const routeResolverServiceModule = angular.module('routeResolverServiceModule', [])
	.factory('routeResolver', downgradeInjectable(RouteResolverService))
	.name;
